import { Deferred } from '../utils/deferred';
import { fallback } from './fallback';
import { filter } from './filter';
import { last } from './last';
import { map } from './map';
export function isOutlet(x) {
    // TODO
    throw new Error('unimplemented');
}
export function createOutlet(descriptor) {
    return new OutletImplementation(descriptor);
}
var OutletImplementation = /** @class */ (function () {
    function OutletImplementation(_descriptor) {
        var _this = this;
        this._descriptor = _descriptor;
        this.getCurrentValue = function () {
            // If our descriptor says we have no value (or the descriptor throws
            // a promise for `getCurrentValue`), then throw a promise that resolves
            // once we do have a value.
            var _a = _this._getState(), error = _a.error, hasError = _a.hasError, hasCurrentValue = _a.hasCurrentValue, value = _a.value;
            if (!hasCurrentValue) {
                throw _this.getValue().then(function () { });
            }
            else if (hasError) {
                throw error;
            }
            return value;
        };
        this.getValue = function () {
            if (_this.nextValue) {
                return _this.nextValue.promise;
            }
            var _a = _this._getState(), error = _a.error, hasError = _a.hasError, hasCurrentValue = _a.hasCurrentValue, value = _a.value;
            if (hasCurrentValue) {
                if (hasError) {
                    return Promise.reject(error);
                }
                return Promise.resolve(value);
            }
            var deferred = (_this.nextValue = new Deferred());
            _this.nextValueUnsubscribe = _this._descriptor.subscribe(_this._getState);
            return _this.nextValue ? _this.nextValue.promise : deferred.promise;
        };
        this.hasCurrentValue = function () { return _this._getState().hasCurrentValue; };
        this.subscribe = function (callback) {
            // Outlets only notify subscribers if something has actually changed.
            var state = _this._getState();
            // TODO: use at max one subscription, and when we have a subscripiton,
            // memoize the latest current state notifications
            return _this._descriptor.subscribe(function () {
                var nextState = _this._getState();
                var shouldNotify = state.hasError !== nextState.hasError ||
                    state.hasCurrentValue !== nextState.hasCurrentValue ||
                    state.value !== nextState.value;
                if (shouldNotify) {
                    state = nextState;
                    callback();
                }
            });
        };
        this._getState = function () {
            var hasError = false;
            var error;
            var hasCurrentValue;
            var value;
            try {
                // For deciding whether we have a value or not, we'll prioritize the
                // behavior of `getCurrentValue` over the response of `hasCurrentValue`.
                value = _this._descriptor.getCurrentValue();
                hasCurrentValue =
                    !_this._descriptor.hasCurrentValue || _this._descriptor.hasCurrentValue();
            }
            catch (errorOrPromise) {
                if (typeof errorOrPromise.then === 'function') {
                    hasCurrentValue = false;
                }
                else {
                    hasCurrentValue = true;
                    hasError = true;
                    error = errorOrPromise;
                }
            }
            if (hasCurrentValue && _this.nextValue) {
                if (_this.nextValueUnsubscribe) {
                    var unsubscribe = _this.nextValueUnsubscribe;
                    delete _this.nextValueUnsubscribe;
                    unsubscribe();
                }
                var nextValue = _this.nextValue;
                delete _this.nextValue;
                if (nextValue) {
                    if (hasError) {
                        nextValue.reject(error);
                    }
                    else {
                        nextValue.resolve(value);
                    }
                }
            }
            return {
                error: error,
                hasError: hasError,
                hasCurrentValue: hasCurrentValue,
                value: hasCurrentValue ? value : undefined,
            };
        };
    }
    OutletImplementation.prototype.fallback = function (value) {
        return fallback(this, value);
    };
    OutletImplementation.prototype.filter = function (predicate) {
        return filter(this, predicate);
    };
    OutletImplementation.prototype.last = function () {
        return last(this);
    };
    OutletImplementation.prototype.map = function (mapFn) {
        return map(this, mapFn);
    };
    return OutletImplementation;
}());
//# sourceMappingURL=Outlet.js.map